<template>
  <div class="shift-page content-430">
    <div class="header-wrapper-430">
      <div class="search-box">
        <div class="ipt-box">
          <Search
            v-model="searchData"
            @handleSearch="handleSearch"
            @handleReset="handleReset"
          ></Search>
        </div>
        <div class="btn-box"></div>
      </div>
      <div class="table-btn-430">
        <Button
          type="primary"
          @click.stop="handleExportExcel"
        >导出Excel</Button>
      </div>
    </div>

    <div class="content">
      <Table
        ref="selection"
        border
        :max-height="tableHeight"
        :columns="shiftColumn"
        :data="tableData"
        :loading="tableLoading"
      >
        <template slot="schoolName" slot-scope="{ row }">
          <TablePoptip :content="row.schoolName"> </TablePoptip>
        </template>
        <template slot="oldClassroomName" slot-scope="{ row }">
          <TablePoptip :content="row.oldClassroomName"> </TablePoptip>
        </template>
        <template slot="newProductName" slot-scope="{ row }">
          <TablePoptip :content="row.newProductName"> </TablePoptip>
        </template>
        <template slot="newClassName" slot-scope="{ row }">
          <TablePoptip :content="row.newClassName"> </TablePoptip>
        </template>

        <template slot="classType" slot-scope="{ row }">
          <div>
            {{ classTypeArr[+row.classType] }}
          </div>
        </template>
        <template slot="enrollStatus">
          <div>调班</div>
        </template>
        <template slot="convertStatus">
          <div>调班成功</div>
        </template>
        <template slot="action" slot-scope="{ row }">
          <div class="table-action-430">
            <span class="action-normal-430" @click="handleToDetail(row)">
              详情
            </span>
          </div>
        </template>
      </Table>
    </div>
    <div class="page-box-430">
      <Page
        :total="pageInfo.total"
        :current="pageInfo.PageNum"
        :page-size="pageInfo.PageSize"
        show-elevator
        show-sizer
        show-total
        @on-change="handlePageNum"
        @on-page-size-change="handlePageSize"
      ></Page>
    </div>
    <Drawer v-model="show" title="调班明细" width="80" @on-close="closeDrawer">
      <Detail ref="details" :exchange-id="selectExchangeId"></Detail>
    </Drawer>
  </div>
</template>

<script>
import Search from './Search';
import { shiftColumn } from '../../assets/data/shiftManage';
import courseSchedulCenterApi from '@/request/courseSchedulCenter/index';
import { downLoadByBlob } from '@/pages/assetsModules/common.js';
import axios from 'axios';
import mixinTableHeight from '@/mixins/mixinTableHeight';
import Detail from '../Detail.vue';
import { mapMutations } from 'vuex';
export default {
  name: 'ShiftPage',
  components: { Search, Detail },
  mixins: [mixinTableHeight],
  beforeRouteLeave(to, from, next) {
    this.PUSH_CACHEROUTE('ShiftPage');
    next();
  },
  data() {
    return {
      shiftColumn: shiftColumn,
      searchData: {},
      tableLoading: false,
      tableData: [],
      classTypeArr: ['', '素质课', '托管课'],
      enrollStatusArr: [],
      convertStatusArr: [],
      pageInfo: {
        total: 0,
        PageNum: 1,
        PageSize: 10
      },
      selectExchangeId: '',
      show: false
    };
  },
  activated() {
    this.classroomStudentRecPage(this.searchData);
  },
  created() {
    this.classroomStudentRecPage();
  },
  methods: {
    ...mapMutations(['SET_CACHEROUTE', 'PUSH_CACHEROUTE']),
    closeDrawer() {
      this.show = false;
    },
    handleToDetail(row) {
      this.selectExchangeId = row.exchangeId;
      this.$nextTick(() => {
        this.$refs.details.classroomStudentRecDetail();
      });
      this.show = true;
      // const { href } = this.$router.resolve({
      //   path: '/courseSchedulCenter/shiftManage/shift/detail',
      //   query: { exchangeId: row.exchangeId }
      // });
      // window.open(href);
    },
    async classroomStudentRecPage(searchData) {
      this.tableLoading = true;
      const params = Object.assign({}, searchData, {
        PageNum: this.pageInfo.PageNum,
        PageSize: this.pageInfo.PageSize
      });
      try {
        const resp = await courseSchedulCenterApi.classroomStudentRecPage(
          params
        );
        if (resp.status === 200) {
          this.tableData = resp.message.list;
          this.tableLoading = false;
          this.pageInfo.total = +resp.message.total;
        }
      } catch (err) {
        this.tableLoading = false;
        console.log('err', err);
      }
    },
    async handleExportExcel() {
      if (!this.searchData.schoolId) {
        this.$Message.error('请选择学校');
        return;
      }
      try {
        const pageInfo = {
          PageNum: 1,
          PageSize: 10000
        };
        const params = Object.assign({}, pageInfo, this.searchData);
        const CancelToken = axios.CancelToken;
        const source = CancelToken.source();
        this.$Spin.show();
        const res = await courseSchedulCenterApi.classroomStudentRecExport(
          params,
          source.token
        );
        this.$Spin.hide();
        if (res) {
          const reader = new FileReader();
          let resData = null;
          reader.readAsText(res.data, 'utf-8');
          reader.onload = () => {
            if (res.data.type === 'application/vnd.ms-excel') {
              this.$Message.success('导出成功');
              this.percent = 100;
              downLoadByBlob(res);
            } else {
              resData = JSON.parse(reader.result);
              this.$Message.error({
                content: resData.error,
                duration: 5
              });
            }
          };
        }
      } catch (err) {
        console.log('err', err);
      }
    },
    handlePageNum(val) {
      this.pageInfo.PageNum = val;
      this.classroomStudentRecPage(this.searchData);
    },
    handlePageSize(val) {
      this.pageInfo.PageNum = 1;
      this.pageInfo.PageSize = val;
      this.classroomStudentRecPage(this.searchData);
    },
    handleSearch(searchData) {
      this.searchData = searchData;
      this.pageInfo.PageNum = 1;
      this.classroomStudentRecPage(searchData);
    },
    handleReset(pageInfo) {
      this.pageInfo = pageInfo;
      this.classroomStudentRecPage();
    }
  }
};
</script>

<style lang="scss" scoped>
.shift-page {
}
</style>
